import { render, staticRenderFns } from "./BurgerMenuIcon.vue?vue&type=template&id=7f9dbec1&scoped=true"
import script from "./BurgerMenuIcon.vue?vue&type=script&lang=ts"
export * from "./BurgerMenuIcon.vue?vue&type=script&lang=ts"
import style0 from "./BurgerMenuIcon.vue?vue&type=style&index=0&id=7f9dbec1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9dbec1",
  null
  
)

export default component.exports